import React from 'react'
import { Grid } from '@material-ui/core'
import { SecaoGenerica } from 'components'

export const FormArquivos = (props) => {
  const { children } = props

  return (
    <Grid item xs={12}>
      <SecaoGenerica titulo="ARQUIVOS RELACIONADOS">
        <Grid item xs={12}>
          {children}
        </Grid>
      </SecaoGenerica>
    </Grid>
  )
}

